<template>
    <CommonTemplate
        class="final-page"
    >
        <template v-slot:top>
            <div class="final-page__top">
                <h1 class="final-page__title">
                    Мы подобрали Вам займы.
                </h1>
                <p class="final-page__desc">
                    Одновременно подайте заявку, как минимум, в 3 компании для гарантированного получения займа.
                </p>
            </div>
        </template>
        <List/>
    </CommonTemplate>
</template>

<script>
import './final-page.scss'

import List from '@/applications/final/components/list/List'

import Cookies from 'js-cookie'
import Store from '@/store'

export default {
    name: 'Final',
    components: {
        List
    },
    beforeRouteEnter(to, from, next) {
        if (Cookies.get('sbg-cpa')) {
            next()
        } else {
            Store.commit('application/load', false)
            next({ name: 'NotFound' })
        }
    }
}
</script>